var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentViewDetailesFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.667a.667.667 0 00-.667.666V6c0 .368.299.667.667.667h6.667A.667.667 0 009.333 6V3.333a.667.667 0 00-.666-.666H2zM2 10a.667.667 0 00-.667.667v2.666c0 .368.299.667.667.667h6.667a.667.667 0 00.666-.667v-2.666A.667.667 0 008.667 10H2zm-.667 8c0-.368.299-.667.667-.667h6.667c.368 0 .666.299.666.667v2.667a.667.667 0 01-.666.666H2a.667.667 0 01-.667-.666V18zM12.667 2.667a.667.667 0 00-.667.666v17.334c0 .368.299.666.667.666H22a.667.667 0 00.667-.666V3.333A.667.667 0 0022 2.667h-9.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentViewDetailesFill);
export default __webpack_public_path__ + "f33cb2d871a6ed6574d95be1d8a88293.svg";
export { ForwardRef as ReactComponent };